import { render, staticRenderFns } from "./rating-score-entry.vue?vue&type=template&id=06579af8&scoped=true&"
import script from "./rating-score-entry.vue?vue&type=script&lang=js&"
export * from "./rating-score-entry.vue?vue&type=script&lang=js&"
import style0 from "./rating-score-entry.vue?vue&type=style&index=0&id=06579af8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06579af8",
  null
  
)

export default component.exports